module.exports = __webpack_public_path__ + "static/img/areaA-33.c51a188.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/areaA-33.png
// module id = 986
// module chunks = 1